import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { PoiListScope } from '../search/domain/models/PoiListScope';
import { AirportCodes } from '../../../types/airports';

export function getShopDineRelaxListUrl(options: {
	airportCode: AirportCodes;
	scope?: PoiListScope;
	query?: string;
}) {
	const { airportCode, scope, query } = options;

	const params =
		typeof window !== 'undefined'
			? new URLSearchParams(window.location.search)
			: new URLSearchParams();

	if (scope) {
		params.set('scope', scope);
	}

	if (query) {
		params.set('query', query);
	}

	if (query === '') params.delete('query');

	const queryString = params.toString() ? `?${params.toString()}` : '';
	return `/${airportCode}${PageRoutes.ShopDineRelax}${queryString}`;
}
